export default {
    CHAT: "/chat/:id(\\d+)",
    SIGN_UP: {
        SIGN_UP: "/sign-up",
        SIGN_UP_CONTINUE: "/sign-up-continue",
        SIGN_UP_LINK: "/continue-sign-up",
    },
    DASHBOARD: "/dashboard",
    ACTIVITY: "/activity",
    LOGIN: "/login",
    ERRORS: {
        NOT_FOUND: "/not-found",
        FORBIDDEN: "/forbidden",
        INTERNAL_ERROR: "/internal-error",
        EXPIRED_CONF_LINK: "/expired-conf-link",
        EXPIRED_CHANGE_EMAIL_LINK: "/change-email-expired",
        EXPIRED_REG_LINK: "/expired-reg-link",
    },
    RESOLUTION_PANEL: {
        ROOT: "/resolution-panel",
        RESOLUTIONS_MANAGEMENT: "/resolution-panel/management",
        RELEASE_REQUESTS: "/resolution-panel/release-requests",
        RELEASE_REQUEST: {
            HOME: "/resolution-panel/release-request/:id(\\d+)",
            OVERVIEW: "/resolution-panel/release-request/:id(\\d+)/overview",
            TENANCY: "/resolution-panel/release-request/:id(\\d+)/tenancy",
            CASE_NOTES: "/resolution-panel/release-request/:id(\\d+)/notes",
            PROPOSE_NEW_SETTLEMENTS: "/resolution-panel/release-request/:id(\\d+)/new-settlements",
            ALL_EVIDENCE: "/resolution-panel/release-request/:id(\\d+)/all-evidence",
        },
        START_RELEASE_REQUEST: {
            ROOT: "/resolution-panel/release-requests/start",
            ROOT_OR_CONTINUE: "/resolution-panel/release-requests/start/:id(\\d+)?",
        },
    },
    MY_PROFILE: "/profile",
    CHANGE_EMAIL: "/change-email",
    COMPANY: {
        DEFAULT: "/company",
        GENERAL: "/company/general",
        BRANCHES: "/company/branches",
        PRODUCTS: "/company/products",
    },
    STAFF: {
        ROOT: "/staff",
        USERS: "/staff/users",
        USER: "/staff-user/:id(\\d+)",
        ROLES: {
            ROOT: "/staff/roles",
            ROLE: "/staff/roles/:roleId",
            NEW_ROLE: "/staff/roles/new",
        },
    },
    PROPERTIES: {
        ROOT: "/properties",
        PROPERTIES_LIST: "/properties/list",
        PROPERTY: "/properties/:id(\\d+)/property",
        CREATE_PROPERTY_ROOT: "/properties/add",
        PROPERTY_VOUCHERS_ROOT: "/properties/vouchers",
        PROPERTY_VOUCHERS_EXACT: "/properties/vouchers/:id(\\d+)",
        MEMBERSHIP: "/properties/:id(\\d+)/membership",
        CLAIMS: {
            HOME: "/properties/:id(\\d+)/claims",
            HISTORY: "/properties/:id(\\d+)/claims-history",
            START: "/properties/:id(\\d+)/claims/start",
        },
        BULK_UPLOAD: "/properties/import",
        END_OF_TENANCY: {
            ROOT: "/properties/:id(\\d+)/end-of-tenancy",
            CREATE: "/properties/:id(\\d+)/end-of-tenancy/create",
        },
    },
    PROPERTY: {
        ROOT: "/properties/:id(\\d+)",
        PROPERTY_DETAILS: "/properties/:id(\\d+)/property",
    },
    TENANCY: {
        ROOT: "/properties/:id(\\d+)",
        TENANCY_DETAILS: "/properties/:id(\\d+)/tenancy",
    },
    ADMIN: {
        USERS: {
            ROOT: "/users",
            CREATE_USER: "/users/create-user",
            USER_PROFILE: "/users/:id(\\d+)",
            PROFILE: "/users/:id(\\d+)/details",
            VOUCHERS: "/users/:id(\\d+)/vouchers",
            PROPERTIES: "/users/:id(\\d+)/properties",
        },
        SETTINGS: {
            ROOT: "/settings",
            ADMINS_FULL_PATH: "/settings/admins",
            PORTAL_SETTINGS: "/portal",
            PORTAL_SETTINGS_FULL_PATH: "/settings/portal",
            ROLES_AND_PERMISSIONS: "/roles-and-permissions",
            ROLES_AND_PERMISSIONS_FULL_PATH: "/settings/roles-and-permissions",
            MEMBERSHIP_RATES: "/membership-rates",
            MEMBERSHIP_RATES_FULL_PATH: "/settings/membership-rates",
            PROFILE: {
                ROOT: "/settings/admins/:id(\\d+)",
                ADMIN_DETAILS: "/settings/admins/:id(\\d+)/details",
            },
            ROLES: {
                ROOT: "/settings/roles",
                ROLE: "/settings/roles/:roleId",
                NEW_ROLE: "/settings/roles/new",
            },
        },
        FINANCE: {
            ROOT: "/finance",
            VOUCHERS: "/vouchers",
            VOUCHERS_FULL_PATH: "/finance/vouchers",
            FAILED_PAYMENTS: "/failed-payments",
            FAILED_PAYMENTS_FULL_PATH: "/finance/failed-payments",
        },
        BUSINESSES: {
            ROOT: "/businesses",
            PROFILE: {
                HOME: "/businesses/companies/:id(\\d+)",
                STAFF: "/businesses/companies/:id(\\d+)/staff",
                DETAILS: "/businesses/companies/:id(\\d+)/details",
                BRANCHES: "/businesses/companies/:id(\\d+)/branches",
                PROPERTIES: "/businesses/companies/:id(\\d+)/properties",
                VOUCHERS: "/businesses/companies/:id(\\d+)/vouchers",
            },
            STAFF_PROFILE: {
                ROOT: "/businesses/companies/:companyId(\\d+)/staff/:id(\\d+)",
                STAFF_DETAILS: "/businesses/companies/:companyId(\\d+)/staff/:id(\\d+)/details",
                STAFF_VOUCHERS: "/businesses/companies/:companyId(\\d+)/staff/:id(\\d+)/vouchers",
                STAFF_PROPERTIES: "/businesses/companies/:companyId(\\d+)/staff/:id(\\d+)/properties",
            },
            COMPANIES: "/businesses/companies",
            BULK_UPLOAD: "/businesses/import",
        },
        PROPERTIES: {
            PROPERTY: "/properties/:id(\\d+)/property",
        },
        VOUCHER_INVOICE: "/voucher-invoice",
    },
    INVITATIONS: {
        REVOKE_INVITE: "/revoke-invite",
        EXPIRED_INVITE: "/expired-invite",
    },
    TENANT_HOME: {
        HOME: "/home",
        MEMBERSHIP: "/home/membership",
        END_OF_TENANCY: "/home/end-of-tenancy",
    },
    TENANT_BILLING: {
        HOME: "/billing",
    },
    TENANT_END_OF_TENANCY: "/membership/end-of-tenancy",
    MISSING_DETAILS: "/missing-details",
    MEMBERSHIP_CERTIFICATE: "/membership-certificate",
};
